import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { ProductsToReviewResponse, SubmitResponse, ReviewInfo, CustomerReviewsResponse, ReviewListResponse, NotReviewListResponse, Review } from '../../models';
import { ReviewInput, ReviewUpdateInput } from '../../inputs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ReviewService extends HttpService<ReviewInput | ReviewUpdateInput | string, ProductsToReviewResponse | CustomerReviewsResponse | ReviewInfo> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'reviews');
  }

  getProductsToReview(customerId: number): Observable<ProductsToReviewResponse> {
    return this.getAllById(`products-to-review`, customerId).pipe(catchError((error) => of(error)));
  }

  getReviewedProducts(customerId: number): Observable<CustomerReviewsResponse> {
    return this.getAllById(`customer`, customerId).pipe(catchError((error) => of(error)));
  }

  deleteReview(reviewId: number): Observable<SubmitResponse> {
    return this.delete(reviewId).pipe(catchError((error) => of(error)));
  }

  // new

  getProductsReviewed(page=1): Observable<ReviewListResponse> {
    return this.getAllPaged('me', page).pipe(catchError((error) => of(error)));
  }
  getProductsToBeReview(page=1): Observable<NotReviewListResponse> {
    console.log('Fetching products to be reviewed for page:', page);
    return this.getAllPaged('me-not-reviewed', page).pipe(catchError((error) => of(error)));
  }
  createReview(review: ReviewInput): Observable<SubmitResponse> {
    return this.create(review).pipe(catchError((error) => of(error)));
  }
  getReviewById(reviewId: string): Observable<Review> {
    return this.getById(reviewId).pipe(catchError((error) => of(error)));
  }
  updateReview(review: ReviewUpdateInput,id:string): Observable<SubmitResponse> {
    return this.update(review,id).pipe(catchError((error) => of(error)));
  }
  getReviewesOfProduct(productId: string,reviewInput:any): Observable<SubmitResponse> {
    return this.create(reviewInput,"product/"+productId).pipe(catchError((error) => of(error)));
  }
 addHelpfullReview(reviewId: string): Observable<SubmitResponse> {
    return this.create(reviewId,reviewId+"/helpful").pipe(catchError((error) => of(error)));
  }
  deleteHelpfullReview(reviewId): Observable<SubmitResponse> {
    return this.delete(reviewId,reviewId+"helpful").pipe(catchError((error) => of(error)));
  }

}
